import React from 'react';
import { Box, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CompanyTypeFilter from './CompanyTypeFilter';

const CompanySearchDropdownPaper = ({
  children,
  selectedTypes,
  onChange,
  filterSize = 'small',
  sx = {},
  ...props
}) => {
  const theme = useTheme();

  return (
    <Paper {...props} sx={sx}>
      <Box
        onMouseDown={(event) => event.preventDefault()}
        sx={{
          px: 0.75,
          py: 0.5,
          borderBottom: 1,
          borderColor: 'divider',
          backgroundColor: theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.035)'
            : 'rgba(0, 0, 0, 0.025)',
        }}
      >
        <CompanyTypeFilter
          selectedTypes={selectedTypes}
          onChange={onChange}
          size={filterSize}
        />
      </Box>
      {children}
    </Paper>
  );
};

export default CompanySearchDropdownPaper;
